import '../dash.css';
import { apiService } from '../service/apiService';
import React, { useEffect, useRef, useState } from "react";

const Dashboardv1 = () => {
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showMetricModal, setShowMetricModal] = useState(false);
  const [showCardModal, setShowCardModal] = useState(false);

  const [kitchens, setKitchens] = useState([]);
  const [cardData, setCardBox] = useState([]);
  const [stockAlerts, setstockAlerts] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const [inventoryMetrics, setinventoryMetrics] = useState([]);

  const [selectedKitchen, setSelectedKitchen] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    loadKitchens();
    loadCardBox();
  }, []);

  /* -----------------------------
      LOAD KITCHENS
  ------------------------------ */
  const loadKitchens = async () => {
    setLoading(true);
    try {
      const data = await apiService.getKitchen();
      setKitchens(data);
    } catch (error) {
      console.error("Failed to load kitchens", error);
    } finally {
      setLoading(false);
    }
  };
  
  /* -----------------------------
      HANDLE SEARCH (WITH FILTER)
  ------------------------------ */
  const handleSearch = async () => {
    setLoading(true);

    const payload = {
      kitchen_id: selectedKitchen || "",
      start_data: startDate || "",
      end_data: endDate || ""
    };

    try {
      const data = await apiService.getDashboardCardBox(payload);
      setCardBox(data.cardBoax);
      setinventoryMetrics(data.inventoryMetrics);
      setstockAlerts(data.stockAlerts);
      setRecentActivities(data.recentActivities);
    } catch (error) {
      console.error("Failed to load filtered data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async () => {
    // Clear all filter states
    setSelectedKitchen("");
    setStartDate("");
    setEndDate("");
    loadCardBox();
  };

  /* -----------------------------
      LOAD DEFAULT CARDBOX (NO FILTER)
  ------------------------------ */
  const loadCardBox = async () => {
    setLoading(true);
    try {
      const data = await apiService.getDashboardCardBox();
      setCardBox(data.cardBoax);
      setinventoryMetrics(data.inventoryMetrics);
      setstockAlerts(data.stockAlerts);
      setRecentActivities(data.recentActivities);
    } catch (error) {
      console.error("Failed to load dashboard", error);
    } finally {
      setLoading(false);
    }
  };


  const MetricCard = ({ metric, isLast }) => (
    <div
      className={`col-lg border-end-lg border-bottom border-bottom-lg-0 border-primary ${isLast ? 'pt-3 pt-lg-0' : 'py-3 py-lg-0'}`}
      style={{ cursor: 'pointer' }}
      onClick={() => {
        setSelectedMetric(metric);
        setShowMetricModal(true);
      }}
    >
      <div className="d-flex flex-between-center mb-3">
        <div className="d-flex align-items-center">
          <div className={`icon-item icon-item-sm bg-${metric.color}-subtle shadow-none me-2`}>
            <span className={`fs--2 fas fa-${metric.icon} text-${metric.color}`}></span>
          </div>
          <h6 className="mb-0 mono-card-text">{metric.title}</h6>
        </div>
        <span className="text-500" data-bs-toggle="tooltip" data-bs-placement="top" aria-label={metric.tooltip} data-bs-original-title={metric.tooltip}>
          <span className="fas fa-info-circle" data-fa-transform="shrink-1"></span>
        </span>
      </div>
      <div className="d-flex ms-3 gap-1">
        <div className={`font-sans-serif lh-1 mb-0 fs-2 pe-2 ${metric.color === 'danger' ? 'text-danger' : ''} ${metric.color === 'warning' ? 'text-warning' : ''}`} id={`Today${metric.id}`}>
          {metric.value}
        </div>
      </div>
    </div>
  );


  const colorClasses = {
    warning: 'text-warning',
    primary: 'text-primary',
    success: 'text-success',
    info: 'text-info'
  };

  const StatCard = ({ title, value, color, icon, bgImage, details }) => {
    return (
      <div
        className="col col mb-3"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setSelectedCard({ title, value, color, icon, bgImage, details });
          setShowCardModal(true);
        }}
      >
        <div className="card statistic-card h-100 border-0 shadow-sm hover-lift">
          <div
            className="bg-holder bg-card opacity-10"
            style={{ backgroundImage: `url('${bgImage}')` }}
          ></div>

          <div className="card-body position-relative">
            <div className="d-flex justify-content-between align-items-center mb-1 ">
              <h6 className="card-title text-muted mb-0 small fw-semibold text-uppercase">
                {title}
              </h6>
              <span className="fs-5 borderv1">{icon}</span>
            </div>
            <div className="d-flex align-items-end justify-content-between">
              <div>
                <div className={`display-2  fs-2 fw-bold font-sans-serif ${colorClasses[color]}`}>
                  {value}
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer bg-transparent border-0 pt-0">
            <div className="progress" style={{ height: '4px' }}>
              <div
                className={`progress-bar bg-${color}`}
                style={{ width: '75%' }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const today = new Date();
  const todaysetdate = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(",", "");

  // Metric Detail Modal
  const MetricDetailModal = () => {
    if (!selectedMetric) return null;

    return (
      <div className={`modal fade ${showMetricModal ? 'show' : ''}`} style={{ display: showMetricModal ? 'block' : 'none' }} tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <div className={`icon-item icon-item-sm bg-${selectedMetric.color}-subtle shadow-none me-2`}>
                  <span className={`fs--2 fas fa-${selectedMetric.icon} text-${selectedMetric.color}`}></span>
                </div>
                <h5 className="modal-title">{selectedMetric.title} - Details</h5>
              </div>
              <button type="button" className="btn-close" onClick={() => setShowMetricModal(false)}></button>
            </div>
            <div className="modal-body">
              <div className="row mb-4">
                <div className="col-12">
                  <h4 className={`text-${selectedMetric.color} mb-2`}>{selectedMetric.value}</h4>
                  <p className="text-muted">{selectedMetric.details.description}</p>
                </div>
              </div>

              {selectedMetric.details.breakdown && (
                <div className="row mb-4">
                  <div className="col-12">
                    <h6 className="mb-3">Category Breakdown</h6>
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>Category</th>
                            <th className="text-end">Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedMetric.details.breakdown.map((item, index) => (
                            <tr key={index}>
                              <td>{item.category}</td>
                              <td className="text-end">{item.count}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {selectedMetric.details.items && (
                <div className="row mb-4">
                  <div className="col-12">
                    <h6 className="mb-3">Critical Items</h6>
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th className="text-end">Current</th>
                            <th className="text-end">Minimum</th>
                            <th className="text-end">Days Left</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedMetric.details.items.map((item, index) => (
                            <tr key={index}>
                              <td>{item.name}</td>
                              <td className="text-end">{item.current}</td>
                              <td className="text-end">{item.min}</td>
                              <td className="text-end">{item.daysLeft}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-12">
                  <div className="alert alert-info">
                    <strong>Note:</strong> {selectedMetric.details.actionRequired || selectedMetric.details.trend || selectedMetric.details.improvement}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowMetricModal(false)}>
                Close
              </button>
              <button type="button" className={`btn btn-${selectedMetric.color}`}>
                View Full Report
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Card Detail Modal
  const CardDetailModal = () => {
    if (!selectedCard) return null;

    return (
      <div className={`modal fade ${showCardModal ? 'show' : ''}`} style={{ display: showCardModal ? 'block' : 'none' }} tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <span className="fs-4 me-2">{selectedCard.icon}</span>
                <h5 className="modal-title">{selectedCard.title} - Detailed View</h5>
              </div>
              <button type="button" className="btn-close" onClick={() => setShowCardModal(false)}></button>
            </div>
            <div className="modal-body">
              <div className="row mb-4">
                <div className="col-12">
                  <div className={`display-4 text-${selectedCard.color} mb-2`}>{selectedCard.value}</div>
                  <p className="text-muted">{selectedCard.details.description}</p>
                </div>
              </div>

              {selectedCard.details.status && (
                <div className="row mb-4">
                  <div className="col-12">
                    <h6 className="mb-3">Status Breakdown</h6>
                    <div className="row">
                      {Object.entries(selectedCard.details.status).map(([key, value]) => (
                        <div key={key} className="col-md-4 mb-2">
                          <div className="card border-0 bg-light">
                            <div className="card-body text-center py-2">
                              <div className="fw-bold fs-5">{value}</div>
                              <small className="text-capitalize text-muted">{key}</small>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {selectedCard.details.recentRequisitions && (
                <div className="row mb-4">
                  <div className="col-12">
                    <h6 className="mb-3">Recent Requisitions</h6>
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Item</th>
                            <th className="text-end">Quantity</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedCard.details.recentRequisitions.map((req, index) => (
                            <tr key={index}>
                              <td>{req.id}</td>
                              <td>{req.item}</td>
                              <td className="text-end">{req.quantity}</td>
                              <td>
                                <span className={`badge bg-${req.status === 'Approved' ? 'success' : 'warning'}`}>
                                  {req.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {selectedCard.details.totalValue && (
                <div className="row">
                  <div className="col-12">
                    <div className={`alert alert-${selectedCard.color} bg-${selectedCard.color}-subtle`}>
                      <strong>Total Value:</strong> {selectedCard.details.totalValue}
                      {selectedCard.details.yoyGrowth && (
                        <span className="float-end">{selectedCard.details.yoyGrowth} YoY Growth</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowCardModal(false)}>
                Close
              </button>
              <button type="button" className={`btn btn-${selectedCard.color}`}>
                Export Data
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div>
        {loading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div className="spinner-border text-primary"></div>
          </div>
        )}

        {/* Your dashboard UI below */}
        {!loading && (
          <div className="content">
            <div className="container-fluid">
              {/* FILTER SECTION */}
              <div className="card mb-3">
                <div className="card-header border-info">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div className="row g-3">

                      {/* SELECT KITCHEN */}
                      <div className="col-lg-5">
                        <select
                          className="form-select"
                          value={selectedKitchen}
                          onChange={(e) => setSelectedKitchen(e.target.value)}
                        >
                          <option value="">Select Kitchen</option>
                          {kitchens.map((item) => (
                            <option key={item.kitchen_id} value={item.kitchen_id}>
                              {item.kitchen_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* START DATE */}
                      <div className="col-lg-2">
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>

                      {/* END DATE */}
                      <div className="col-lg-2">
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>

                      {/* SEARCH BUTTON */}
                      <div className="col-lg-2">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          onClick={handleSearch}
                        >
                          Search
                        </button>
                      </div>

                      {/* RESET BUTTON */}
                      <div className="col-lg-1">
                        <button
                          type="button"
                          className="btn btn-dark w-100"
                          onClick={handleReset}
                        >
                          Reset
                        </button>
                      </div>

                    </div>
                  </form>
                </div>
              </div>


              {/* MAIN CARD BOX */}
              <div className="row g-3 mb-3">
                {cardData.map(card => (
                  <StatCard
                    key={card.id}
                    title={card.title}
                    value={card.value}
                    color={card.color}
                    icon={card.icon}
                    bgImage={card.bgImage}
                    details={card.details}
                  />
                ))}
              </div>

              {/* MAIN INVENTORY OVERVIEW */}
              <div className="row mb-4">
                <div className="col-md-12">
                  <div className="card border-primary">
                    <div className="card-header bg-primary text-white p-2 rounded-top">
                      <div className="col-sm-auto d-flex align-items-center">
                        <span className="fa-stack me-2">
                          <i className="fas fa-circle fa-stack-2x text-300"></i>
                          <i className="fa-inverse fa-stack-1x text-primary fas fa-boxes"></i>
                        </span>
                        <div>
                          <h6 className="mb-0 fs-0 text-white">Inventory Overview - Today - {todaysetdate}</h6>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {inventoryMetrics.map((metric, index) => (
                          <MetricCard
                            key={metric.id}
                            metric={metric}
                            isLast={index === inventoryMetrics.length - 1}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              {/* STOCK ALERTS AND RECENT ACTIVITY */}
              <div className="row">
                {/* Stock Alerts */}
                <div className="col-lg-6 mb-4">
                  <div className="card stock-alerts-card border-0 shadow-sm h-100">
                    <div className="card-header bg-gradient-primary text-white p-3 rounded-top-3">
                      <div className="d-flex align-items-center">
                        <span className="fas fa-exclamation-triangle me-2 fs-2"></span>
                        <h5 className="mb-0 fw-semibold text-white">Stock Alerts</h5>
                        <span className="badge bg-white text-primary ms-2">{stockAlerts.length}</span>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <div className="table-responsive">
                          <table className="table table-hover mb-0">
                            <thead className="table-light">
                              <tr>
                                <th className="ps-3">Item</th>
                                <th>Category</th>
                                <th>Current</th>
                                <th>Min</th>
                                <th className="pe-3">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {stockAlerts.slice(0, 100).map(alert => (
                                <tr key={alert.id} className="align-middle">
                                  <td className="ps-3">
                                    <div className="d-flex align-items-center">
                                      <div className={`status-indicator me-2 bg-${alert.status === 'Out' ? 'danger' : 'warning'}`}></div>
                                      <span className="fw-medium">{alert.item}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <span className="text-muted">{alert.category}</span>
                                  </td>
                                  <td>
                                    <span className={`fw-bold ${alert.currentStock === 0 ? 'text-danger' : 'text-warning'}`}>
                                      {alert.currentStock}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-muted">{alert.minStock}</span>
                                  </td>
                                  <td className="pe-3">
                                    <span className={`badge badge-${alert.status === 'Out' ? 'danger' : 'warning'} rounded-pill px-2 py-1`}>
                                      {alert.status === 'Out' ? 'Out of Stock' : 'Low Stock'}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Recent Activity */}
                <div className="col-lg-6 mb-4">
                  <div className="card recent-activity-card border-0 shadow-sm h-100">
                    <div className="card-header bg-gradient-info text-white p-3 rounded-top-3">
                      <div className="d-flex align-items-center">
                        <span className="fas fa-history me-2 fs-2"></span>
                        <h5 className="mb-0 fw-semibold text-white">Recent Activity</h5>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        <div className="activity-timeline">
                          {recentActivities.map((activity, index) => (
                            <div key={index} className="activity-item d-flex position-relative p-3">
                              <div className="activity-icon me-3">
                                <div className={`icon-circle bg-${activity.type === 'add' ? 'success' : activity.type === 'use' ? 'danger' : activity.type === 'alert' ? 'warning' : 'primary'}-subtle`}>
                                  <span className={`fas fa-${activity.icon} text-${activity.type === 'add' ? 'success' : activity.type === 'use' ? 'danger' : activity.type === 'alert' ? 'warning' : 'primary'}`}></span>
                                </div>
                                {index < recentActivities.length - 1 && <div className="timeline-connector"></div>}
                              </div>
                              <div className="activity-content flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start mb-1">
                                  <span className="fw-medium">{activity.action}</span>
                                  <small className="text-muted">{activity.time}</small>
                                </div>
                                <p className="text-muted mb-0 small">{activity.description}</p>
                                {activity.quantity && (
                                  <div className="mt-1">
                                    <span className={`badge bg-${activity.type === 'add' ? 'success' : 'danger'}-subtle text-${activity.type === 'add' ? 'success' : 'danger'} rounded-pill`}>
                                      {activity.quantity}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* Modals */}
              <MetricDetailModal />
              <CardDetailModal />

              {/* Modal Backdrop */}
              {showMetricModal || showCardModal ? (
                <div
                  className="modal-backdrop fade show"
                  onClick={() => {
                    setShowMetricModal(false);
                    setShowCardModal(false);
                  }}
                ></div>
              ) : null}
            </div>
          </div>
        )}

      </div>


    </>

  );
};

export default Dashboardv1;